import React, { useEffect, useRef } from "react";

const Backdrop = ({ onClick }) => (
  <div
    className="fixed inset-0 bg-black/40 backdrop-blur-[1px]"
    onClick={onClick}
  />
);

export default function ConfirmModal({
  open,
  title = "Onay gerekiyor",
  description = "Bu işlemi yapmak istediğinize emin misiniz?",
  confirmText = "Evet, sil",
  cancelText = "Vazgeç",
  confirmBtnClass = "bg-red-600 hover:bg-red-700 text-white",
  cancelBtnClass = "border border-gray-300 text-gray-700 bg-white hover:bg-gray-50",
  onConfirm,
  onCancel,
}) {
  const dialogRef = useRef(null);

  // ESC ile kapat
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <Backdrop onClick={onCancel} />
      <div
        ref={dialogRef}
        className="relative w-full max-w-md rounded-2xl bg-white shadow-xl ring-1 ring-black/5"
      >
        <div className="p-5 sm:p-6">
          <h3 className="text-lg font-bold text-gray-900">{title}</h3>
          <p className="mt-2 text-sm text-gray-600">{description}</p>

          <div className="mt-5 flex flex-col-reverse sm:flex-row gap-2 sm:gap-3">
            <button
              type="button"
              onClick={onCancel}
              className={`inline-flex justify-center rounded-full px-4 py-2 text-sm font-medium ${cancelBtnClass}`}
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`inline-flex justify-center rounded-full px-4 py-2 text-sm font-semibold ${confirmBtnClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
